import { AccountApi } from '@linktivity/ars-neo';
import config from './config';

const accountApi = new AccountApi(config);

export default accountApi;
